import { render, staticRenderFns } from "./Boutique.vue?vue&type=template&id=37658d26&scoped=true&"
import script from "./Boutique.vue?vue&type=script&lang=js&"
export * from "./Boutique.vue?vue&type=script&lang=js&"
import style0 from "./Boutique.vue?vue&type=style&index=0&id=37658d26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37658d26",
  null
  
)

export default component.exports